import React, { useEffect, useRef } from "react";
import { ActivityIndicator, Animated, ScrollView, View } from "react-native";
import moment from "moment";
import { brandColor } from "@/components/globalStyle";
import { Review } from "@/components/shared/PayWall";
import reviews from "@/components/reviews.json";
import tw from "twrnc";
import { t } from "@/localization";

// Review dates are written in English ("Dec 19, 2023"); show them in the
// user's language.
export const reviewDate = (date) => {
  const parsed = moment(date, "MMM D, YYYY", "en", true);
  return parsed.isValid()
    ? parsed.locale(moment.locale()).format(t("MMM D, YYYY"))
    : date;
};

export const LoadingScreen = () => {
  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const timer = setTimeout(() => {
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: true,
      }).start();
    }, 500);
    return () => clearTimeout(timer);
  }, [fadeAnim]);

  const currentReview = reviews[Math.floor(Math.random() * reviews.length)];

  return (
    <ScrollView
      style={tw`w-full`}
      contentContainerStyle={tw`flex-grow items-center justify-center px-8 py-8`}
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
    >
      <View style={tw`items-center justify-center`}>
        <ActivityIndicator color={brandColor} size={"large"} />
      </View>

      <Animated.View style={[tw`w-full mt-6`, { opacity: fadeAnim }]}>
        <Review
          {...currentReview}
          text={t(currentReview.text)}
          date={reviewDate(currentReview.date)}
          transparent
          fullWidth
          style={tw`my-0 self-center`}
        />
      </Animated.View>
    </ScrollView>
  );
};
